import { render, staticRenderFns } from "./FloatingLayer.vue?vue&type=template&id=b5933268&scoped=true&"
import script from "./FloatingLayer.vue?vue&type=script&lang=js&"
export * from "./FloatingLayer.vue?vue&type=script&lang=js&"
import style0 from "./FloatingLayer.vue?vue&type=style&index=0&id=b5933268&lang=scss&scoped=true&"
import style1 from "./FloatingLayer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5933268",
  null
  
)

export default component.exports
import {QColor} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QColor})
